import { Button, Modal } from "@veneer/core";
import { useTranslation } from "react-i18next";

type props = {
  setOpenCloseModal: () => void,
  openModal: boolean,
  titleMessage: string,
  message: string,
  onClickOk: () => void,
  idKey: string
}

export const ModalInformational = ({
  setOpenCloseModal,
  openModal,
  titleMessage,
  message,
  onClickOk,
  idKey,
}: props) => {
  const [t] = useTranslation("global");
  return (
    <div style={{ position: "relative" }}>
      <Modal
        align="center"
        id={idKey}
        show={openModal}
        onClose={setOpenCloseModal}
        title={titleMessage}
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button onClick={onClickOk}>{t("header.closebutton")}</Button>
          </div>
        }
      >
        <p>{message}</p>
      </Modal>
    </div>
  );
};
